import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { rolesApi as n } from "@maat/api-main";
//#region src/workspaces/useRoleMembersQuery.ts
var r = (r) => t({
	queryKey: e.roleMembers(r),
	queryFn: () => n.getRoleMembers(r),
	enabled: !!r
});
//#endregion
export { r as useRoleMembersQuery };
